module.exports = __webpack_public_path__ + "img/background.df95105b.png";